import {createSelector} from 'reselect';

const makeIsPaymentOptionDisabled = (
  getIsDisabledByDeliveryOption,
  getIsOptionDisabledByOrderSummaryPaymentOptions,
  getIsDisabledByPaymentSpecificRule,
) => createSelector(
  [getIsDisabledByDeliveryOption, getIsOptionDisabledByOrderSummaryPaymentOptions, getIsDisabledByPaymentSpecificRule],
  (isDisabledByDelivery,
    isDisabledByOrderSummaryPaymentOptions,
    isDisabledByRule) => !!isDisabledByDelivery
    || !!isDisabledByRule || !!isDisabledByOrderSummaryPaymentOptions,
);

export default makeIsPaymentOptionDisabled;
